import { getQueryParams } from '../helpers/urlParts';
const QUERY_STRING = 'QUERY_STRING';

const initialState = {
  queryString: undefined,
  queryParams: {}
};

const uriReducer = (state = initialState, action) => {
  switch (action.type) {
  case QUERY_STRING: {
    return {
      queryString: action.payload,
      queryParams: getQueryParams(action.payload)
    };
  }
  default: {
    return state;
  }
  }
};

export default uriReducer;



// WEBPACK FOOTER //
// ./src/reducers/uri_reducer.js